var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Docs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0 {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t.st1 {\n\t\t\tdisplay: inline;\n\t\t}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.096,7.771l-5.993-5.994C20.673,1.347,20.078,1.1,19.469,1.1h-9.077c-1.274,0-2.31,1.036-2.31,2.31v1.54H6.54 c-1.274,0-2.31,1.036-2.31,2.31v21.33c0,1.274,1.036,2.31,2.31,2.31h15.07c1.274,0,2.31-1.036,2.31-2.31v-1.547h1.543 c1.274,0,2.31-1.036,2.31-2.31V9.404C27.773,8.787,27.533,8.207,27.096,7.771z M24.701,7.92h-3.238c-0.281,0-0.51-0.229-0.51-0.51 V4.172L24.701,7.92z M22.12,28.59c0,0.281-0.229,0.51-0.51,0.51H6.54c-0.281,0-0.51-0.229-0.51-0.51V7.26 c0-0.281,0.229-0.51,0.51-0.51h1.542v17.982c0,1.274,1.036,2.31,2.31,2.31H22.12V28.59z M25.463,25.243H10.392 c-0.281,0-0.51-0.229-0.51-0.51V3.41c0-0.281,0.229-0.51,0.51-0.51h8.761v4.51c0,1.274,1.036,2.31,2.31,2.31h4.51v15.012 C25.973,25.014,25.744,25.243,25.463,25.243z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.424,11.878H12.431c-0.497,0-0.9,0.403-0.9,0.9s0.403,0.9,0.9,0.9h10.994c0.497,0,0.9-0.403,0.9-0.9 S23.921,11.878,23.424,11.878z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.431,9.223h4.408c0.497,0,0.9-0.403,0.9-0.9s-0.403-0.9-0.9-0.9h-4.408c-0.497,0-0.9,0.403-0.9,0.9 S11.934,9.223,12.431,9.223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.424,16.333H12.431c-0.497,0-0.9,0.403-0.9,0.9s0.403,0.9,0.9,0.9h10.994c0.497,0,0.9-0.403,0.9-0.9 S23.921,16.333,23.424,16.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.424,20.788H12.431c-0.497,0-0.9,0.403-0.9,0.9s0.403,0.9,0.9,0.9h10.994c0.497,0,0.9-0.403,0.9-0.9 S23.921,20.788,23.424,20.788z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.fbdd2139.svg";
export { ForwardRef as ReactComponent };